import { render, staticRenderFns } from "./index copy.vue?vue&type=template&id=4aa91d3c&scoped=true&"
import script from "./index copy.vue?vue&type=script&lang=ts&"
export * from "./index copy.vue?vue&type=script&lang=ts&"
import style0 from "./index copy.vue?vue&type=style&index=0&id=4aa91d3c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa91d3c",
  null
  
)

export default component.exports